module.exports = __webpack_public_path__ + "img/gift-assistant.5280df28.gif";